import * as React from 'react';

import type { Props } from 'bundles/accomplishments/api/withDegreeRecommendationData';
import withDegreeRecommendationData from 'bundles/accomplishments/api/withDegreeRecommendationData';
import { mapCollectionsForCarousel } from 'bundles/collections-carousel/utils/mappingUtils';
import { CollectionsContainer } from 'bundles/collections-common';

export const DegreesCollection = ({ degreesForCollectionCarousel, loading }: Props) => {
  if (!loading && (!degreesForCollectionCarousel || degreesForCollectionCarousel?.length < 1)) return null;

  return (
    <section className="rc-DegreeCarousel-logged-in-home">
      <div className="recommendation-modules-container">
        <div className="rc-RecommendationsCollection">
          <CollectionsContainer
            collections={mapCollectionsForCarousel([
              { entries: degreesForCollectionCarousel, __typename: 'DegreeListV3' },
            ])}
            isCollectionsLoading={loading}
          />
        </div>
      </div>
    </section>
  );
};

export default withDegreeRecommendationData(DegreesCollection);
